import { render, staticRenderFns } from "./DeudaProveedores.vue?vue&type=template&id=4cf84684&"
import script from "./DeudaProveedores.vue?vue&type=script&lang=js&"
export * from "./DeudaProveedores.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports